import { indigo } from '@mui/material/colors';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/SwipeableDrawer';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { withStyles } from 'tss-react/mui';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getUser } from '../../helpers/token';
import Header from '../Header/Header';
import DashboardMenuItems from './DashboardMenuItems';

const drawerWidth = 180;

const styles = theme => ({
  root: {
    display: 'flex',
  },
  paper: {
    background: theme.palette.background.light,
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    zIndex: 200, // smaller zIndex than default in order to display editor tooltips over drawer
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: '55px',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 3px',
    ...theme.mixins.toolbar,
    paddingTop: 65,
  },
  content: {
    wordWrap: 'break-word',
    wordBreak: 'break-word',
    width: `calc(100% - ${drawerWidth}px)`,
    flexGrow: 1,
  },
  topPaper: {
    background: indigo[600],
    padding: theme.spacing(3, 2),
  },
  avatar: {
    width: 50,
    height: 50,
  },
  typography: {
    fontWeight: 500,
  },
});
class DashboardMenu extends Component {
  state = {
    open: this.props.open === 'true',
    user: null,
  };

  componentDidMount() {
    const user = getUser();
    if (window.innerWidth < 576 || !user) {
      this.setState({ open: false, variant: undefined });
    } else if (window.innerWidth < 992) {
      this.setState({ open: false, variant: 'permanent' });
    } else {
      this.setState({
        open: this.props.open !== 'false',
        variant: 'permanent',
      });
    }
    this.setState({
      user,
    });
  }

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;
    const drawer = (
      <Drawer
        variant={this.state.variant}
        className={classNames(classes.drawer, {
          [classes.drawerOpen]: this.state.open,
          [classes.drawerClose]: !this.state.open,
        })}
        classes={{
          paper: classNames(classes.paper, {
            [classes.drawerOpen]: this.state.open,
            [classes.drawerClose]: !this.state.open && this.state.variant,
          }),
        }}
        onOpen={this.handleDrawerOpen}
        onClose={this.handleDrawerClose}
        open={this.state.open}
      >
        <div className={classes.toolbar}>
          <IconButton
            onClick={
              this.state.open ? this.handleDrawerClose : this.handleDrawerOpen
            }
            size="large"
          >
            {this.state.open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </div>
        <DashboardMenuItems
          active={this.props.active}
          open={this.state.open}
          unreadCountOffset={this.props.unreadCountOffset}
        />
      </Drawer>
    );

    return (
      <>
        <Header
          hideSearch
          active={this.props.activePage || 'dashboard'}
          drawerItems={
            <DashboardMenuItems
              active={this.props.active}
              open={this.state.open}
              unreadCountOffset={this.props.unreadCountOffset}
            />
          }
        />
        <div className={classes.root}>
          {!this.props.isMobileView && drawer}
          <main className={classes.content}>{this.props.content}</main>
        </div>
      </>
    );
  }
}

DashboardMenu.defaultProps = {
  query: undefined,
  open: undefined,
};

DashboardMenu.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  query: PropTypes.objectOf(PropTypes.string),
  active: PropTypes.string.isRequired,
  content: PropTypes.element.isRequired,
  open: PropTypes.string,
};

export default withStyles(DashboardMenu, styles, {
  withTheme: true,
  name: 'DashboardMenu',
});
